var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24Expand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.002 4.025c.55.003.995.45.995 1L20 9.998c0 .553-.447 1.002-1 1.002-.552 0-1-.448-1-1l-.002-2.585-3.291 3.291c-.195.195-.451.293-.707.293-.255 0-.511-.098-.707-.293-.39-.39-.39-1.024 0-1.414l3.28-3.28L13.996 6c-.553-.003-1-.454-.996-1.005.003-.55.45-.995 1-.995h.005l4.997.025zm-9.709 9.268c.391-.39 1.023-.39 1.414 0 .391.391.391 1.023 0 1.414L7.415 18 10 18c.553 0 1 .448 1 1.001-.001.552-.448 1-1 1h-.001l-4.975-.004c-.55 0-.996-.445-.999-.995L4 14.005c-.003-.552.443-1.002.995-1.005H5c.55 0 .997.444 1 .995l.013 2.578 3.28-3.28z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24Expand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon _ 24 _ expand.50cca617.svg";
export { ForwardRef as ReactComponent };